import React from 'react'
import { Row, Col } from 'react-bootstrap'
import ReactTooltip from 'react-tooltip'
import Slider, { Range } from 'rc-slider';
import NumberFormat from 'react-number-format';
import 'rc-slider/assets/index.css';
import './style.scss'

const Index = ({handleSlideChange, activeSelection}) => {
    return(
        <div className="select-email-range-container">
            <div className="price-container">
                <div className="price-display-container">
                    <div className="price-display-box">
                        <div className="inner-price-display-box">
                            <Row>
                                <Col className="details-col my-auto">
                                    <h4 className="plan-title">E-postutsendelser</h4>
                                    <p className="plan-description">Pris oppgitt er eksklusiv moms</p>
                                </Col>
                                <Col className="price-col my-auto">
                                    <span className="price-display"><NumberFormat thousandSeparator=" " displayType="text" value={activeSelection.price}/>kr<span className="small">per måned</span></span>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
            <div className="select-container">
                <p className="description">E-postutsendelser i måneden</p>
                <Slider 
                    onBeforeChange={(e) => handleSlideChange(e)}
                    trackStyle={{ 
                        backgroundColor: '#3699FF', 
                        height: 6 
                    }}
                    handleStyle={{
                        height: 17.5,
                        width: 17.5,
                        backgroundColor: '#3699FF',
                    }}
                    dotStyle={{
                        height: 17.5,
                        width: 17.5,
                        top: -5,
                        marginLeft: -9,
                        borderColor: "#E1F0FF"
                    }}
                    activeDotStyle={{
                        backgroundColor: '#3699FF',
                    }}
                    railStyle={{ 
                        backgroundColor: '#E1F0FF', 
                        height: 6 
                    }} className="amount-slider" 
                    min={0} 
                    max={100} 
                    step={null} 
                    marks={{
                        0: <strong className="amount">250</strong>,
                        20: <strong className="amount">500</strong>,
                        40: <strong className="amount">1 000</strong>,
                        60: <strong className="amount">2 500</strong>,
                        80: <strong className="amount">5 000</strong>,
                        100: <strong className="amount">10 000</strong>
                    }}
                />
            </div>
        </div>
    )
}

export default Index
